export default __webpack_public_path__ + "static/fintech-award-ed15ce8811aa78ccef4950a6be98c936.svg";